import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    // 初始化时隐藏蒙板
    this.hide()
    
    // 监听表单提交事件
    this.element.addEventListener("submit", () => {
      this.show()
    })
  }

  show() {
    this.overlayTarget.classList.remove("hidden")
  }

  hide() {
    this.overlayTarget.classList.add("hidden")
  }
} 